import { render, staticRenderFns } from "./NewFee.vue?vue&type=template&id=ebab8614&"
import script from "./NewFee.vue?vue&type=script&lang=js&"
export * from "./NewFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports